const initialState = () => ({
  records: {}
})

const state = initialState()

const getters = {
  byId: state => id => state.records[id]
}

const actions = {
  resetState({ commit }) {
    commit('RESET_STATE')
  },

  getAssetData({ commit, dispatch, getters }, asset) {
    const id = asset.id

    if (getters.byId(id)) {
      console.log(`already present: ${id}`, getters.byId(id))

      return
    }

    const { eventId, menuId, installationId } = JSON.parse(asset.data)

    const promises = {
      event: dispatch('events/getRecord', eventId, { root: true }),
      menu: dispatch('menu/getRecord', menuId, { root: true }),
      installation: dispatch('installations/getRecord', installationId, {
        root: true
      }),
      images: dispatch('events/getImages', eventId, { root: true })
    }

    commit('STORE_ASSET', {
      id,
      promises,
      data: {
        eventId,
        menuId,
        installationId
      }
    })
  }
}

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, initialState())
  },

  STORE_ASSET(state, { id, promises, data }) {
    const { records } = state

    records[id] = { promises, data }
  },
  DELETE_ASSET(state, id) {
    delete state.records[id]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
